export default __webpack_public_path__ + "static/media/MarkPro-Light.478dd278.woff";